export default "/images/pergamum.svg?fe6f42426ab2baa275240041c693122d";